import { EmailClientsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisEmailClientsRoute() {
  const { workspaceId } = Route.useParams();
  return <EmailClientsRoute segment="analysis" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/email-clients')({
  component: AnalysisEmailClientsRoute,
});
